import React from 'react';
import Icon from '../../../components/AppIcon';

const PreviewTable = ({ rows, columns }) => {
  if (!rows?.length) return null;

  const validRows = rows?.filter(r => !r?._errors?.length);
  if (!validRows?.length) return null;

  const displayRows = validRows?.slice(0, 10);

  return (
    <div className="border border-border rounded-lg overflow-hidden">
      <div className="bg-surface px-4 py-2.5 border-b border-border flex items-center justify-between">
        <p className="text-xs font-semibold text-text-secondary uppercase tracking-wide">
          Preview — {validRows?.length} valid rows {validRows?.length > 10 ? '(showing first 10)' : ''}
        </p>
        <Icon name="Eye" size={14} className="text-text-secondary" />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className="bg-surface border-b border-border">
              <th className="px-3 py-2 text-left text-text-secondary font-medium">#</th>
              {columns?.map(col => (
                <th key={col} className="px-3 py-2 text-left text-text-secondary font-medium whitespace-nowrap">{col}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {displayRows?.map((row, i) => (
              <tr key={i} className="hover:bg-surface/50">
                <td className="px-3 py-2 text-text-secondary">{row?._rowIndex}</td>
                {columns?.map(col => (
                  <td key={col} className="px-3 py-2 text-text-primary max-w-[160px] truncate" title={row?.[col]}>
                    {row?.[col] ?? <span className="text-text-secondary italic">—</span>}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PreviewTable;
